import React from 'react'
import './MenuIdiomasV.css'

import { connect } from 'react-redux'
import { toggleOpenProyecto } from '../../modules/reducer'

import { useSpring, animated } from 'react-spring'

const MenuProyectosV = ({
  visible,
  grupoProyecto,
  idProyecto,
  style,
  toggleOpenProyecto,
  idioma
}) => {
  const { height } = useSpring({
    height: visible ? grupoProyecto.length * 38 : 0
  })

  return (
    <animated.div
      className="menu-v"
      style={{
        top: 0,
        height,
        left: 0,
        width: '16em',
        ...style
      }}
    >
      {typeof grupoProyecto !== 'undefined'
        ? grupoProyecto.map(proyecto => (
            <>
              <div
                style={{
                  width: '90%',
                  margin: '0 5%',
                  borderTop: '1px solid white'
                }}
              />
              <div
                className="menu-v-a"
                style={{
                  fontWeight: idProyecto === proyecto.id ? 500 : 300
                }}
                onClick={e => {
                  if (proyecto.id !== idProyecto) {
                    window.location.href = `${proyecto.url}#/${idioma}/`
                  } else {
                    toggleOpenProyecto()
                  }
                }}
              >
                {idioma === 'es' ? proyecto.title.toUpperCase() : proyecto.titleIngles.toUpperCase()}
              </div>
            </>
          ))
        : null}
    </animated.div>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  const grupoProyecto = reducer.grupoProyecto
  const idProyecto = reducer.idProyecto

  let grupo = undefined
  if (ownProps.todo) {
    grupo = grupoProyecto
  } else {
    if (typeof grupoProyecto !== 'undefined') {
      grupo = []
      grupoProyecto.forEach(proyecto => {
        if (idProyecto !== proyecto.id) {
          grupo.push(proyecto)
        }
      })
    }
  }

  return {
    visible: reducer.openProyecto,
    grupoProyecto: grupo,
    idProyecto: reducer.idProyecto,
    idioma: reducer.idioma
  }
}

const mapDispatchToProps = { toggleOpenProyecto }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuProyectosV)
